import script from "./second-batch.vue?vue&type=script&setup=true&lang=ts"
export * from "./second-batch.vue?vue&type=script&setup=true&lang=ts"

import "./second-batch.vue?vue&type=style&index=0&id=41860926&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41860926"]])

export default __exports__